// import components
import DrawerFormSkeleton from 'components/shared/CRUD/components/DrawerFormSkeleton';
import TravelArrangementsForm from './TravelArrangementsForm';

// import hooks
import useGetTravelArrangementsById from '../hooks/useGetTravelArrangementsById';

// import types
import { CreateEditFormProps, TravelArrangementsData } from '../types';

const CreateEditForm = ({
  rowData,
  handleClose,
  isCopy,
  employeeId,
  isDrawerOpen
}: CreateEditFormProps) => {
  const { data, isFetching, isLoading } =
    useGetTravelArrangementsById<TravelArrangementsData>(
      {
        employeeId: employeeId,
        empTrvArrangementId: rowData?.empTrvArrangementId
      },
      {
        enabled: !!employeeId && !!rowData?.empTrvArrangementId && isDrawerOpen
      }
    );

  return isFetching || isLoading ? (
    <DrawerFormSkeleton count={3} />
  ) : (
    <TravelArrangementsForm
      rowData={data ?? {}}
      employeeId={employeeId}
      handleClose={handleClose}
      isCopy={isCopy}
    />
  );
};

export default CreateEditForm;
